import { Label } from 'react-bootstrap';
import { ISwapFailureAnalysis } from '@nkr/models/index';

export const renderCenter = (centerAlias: string, rdnCenterAlias: string, isAdpPartner: boolean, swapFailure: ISwapFailureAnalysis) => {
    let bsStyle = '';

    if (swapFailure != null) {
        if (swapFailure.category == 'Green') {
            bsStyle = 'success';
        }

        if (swapFailure.category == 'LV') {
            bsStyle = 'warning';
        }

        if (swapFailure.category == 'NV') {
            bsStyle = 'info';
        }

        if (swapFailure.category == 'Red') {
            bsStyle = 'danger';
        }
    }

    if (bsStyle != '') {
        return <Label bsStyle={bsStyle} style={{ fontSize: '100%', fontWeight: 'normal' }}>{centerAlias}</Label>;
    } else {
        if (rdnCenterAlias == '') {
            return <span style={{ fontWeight: 'normal' }}>{centerAlias}</span>;
        } else {
            return <><span style={{ fontWeight: 'normal' }}>{centerAlias}</span> (<span style={{ color: 'red' }}>{rdnCenterAlias}</span>)</>;
        }
    }
}